import { ROUND_TO_INT } from "./index117.js";
import { Knapsack } from "./index248.js";
function FloatKnapsack(values, target, roundBy = ROUND_TO_INT) {
	target = Math.round(target * roundBy);
	values = values.map((v) => Math.round(v * roundBy));
	return Knapsack({
		values,
		target
	}) / roundBy;
}
export { FloatKnapsack };

//# sourceMappingURL=index249.js.map